import "../../assets/styles/components/button.scss";
import { Link } from "react-router-dom";
import React, { Component, useRef } from "react";
import { Button } from "antd";
import parse from "html-react-parser";
import Icon from "@mdi/react";

interface Props {
  title?: string;
  to?: string;
  children?: object;
  width?: string;
  height?: string;
  background?: string;
  onClick?: () => void;
  outlined?: boolean;
  className?: string;
  positionIcon?: string;
  color?: string;
  border?: string;
  display?: string;
  isSubmit?: boolean;
  loading?: boolean;
  disabled?: boolean;
  style?: object;
  titleStyle?: any;
  icon?: any;
  iconSize?: string;
  iconColor?: string;
  form?: any;
}
const MainButton: React.FC<Props> = ({
  title,
  to = "#",
  children,
  onClick,
  height = "45px",
  width = "200px",
  background = "#4D7E7F",
  outlined = false,
  className,
  positionIcon = "left",
  color = "#fff",
  border,
  display = "flex",
  isSubmit = false,
  loading = false,
  disabled = false,
  style,
  titleStyle,
  icon,
  iconSize = "30",
  iconColor = "#4D7E7F",
  form,
}) => {
  if (positionIcon == "right") {
    positionIcon = "right";
  } else {
    positionIcon = "left";
  }
  const htmlType = isSubmit ? "submit" : "button";

  const submitRef = useRef<any>(null);

  const onSubmit = () => {
    // console.log("check...");
    submitRef.current.click();
  };

  return (
    // <Link className="none-underline" to={to}>
    <div
      className={`btn ${
        outlined
          ? "btn-main-outlined"
          : disabled
          ? "btn-main disabled"
          : "btn-main"
      } ${className} ${loading ? "loading" : ""}`}
      onClick={isSubmit ? onSubmit : disabled ? () => {} : onClick}
      style={{
        width: width,
        height: height,
        display: "flex",
        backgroundColor: outlined ? "transparent" : background,
        border: border,
        ...style,
      }}
    >
      <Button
        ref={submitRef}
        htmlType={htmlType}
        style={{ display: "none" }}
        onClick={() => {
          if (form) {
            form?.submit();
          } else {
            console.log("form =>", form);
            console.log("form is required!");
          }
        }}
      ></Button>
      <div
        style={{
          display: display,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>{positionIcon == "left" ? children : ""}</div>
        <div
          className={`${outlined ? "title-btn-outlined" : "title-btn-normal"}`}
          style={{
            margin:
              titleStyle?.margin !== undefined
                ? titleStyle?.margin
                : "0px 10px",
            color: color,
            ...titleStyle,
          }}
        >
          {loading ? (
            "loading..."
          ) : (
            <span>
              {icon && (
                <>
                  <Icon
                    path={icon}
                    size={iconSize}
                    color={iconColor}
                    style={{ marginRight: "7px", marginBottom: "2px" }}
                  />
                </>
              )}{" "}
              {parse(title || "")}
            </span>
          )}
        </div>
        <div>{positionIcon === "right" ? children : ""}</div>
      </div>
    </div>
    // </Link>
  );
};
export default MainButton;
